import { Typography } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, getColumnValue, numberColumn, textColumn, timeColumn, yesNoColumn } from "./columnHelpers";
import { EventDate } from "@components/EventDate";
import { dateFromTime, formatTime, formatTimeForDatabase } from "@utils/dates";
import { addMinutes, differenceInMinutes } from "date-fns";

export const timeSlotsRelationship = {
    collapsible: true,
    title: 'Shifts',
    tint: 'default',
    type: 'table',
    sort: [['date'], ['start_time']],
    columns: [
        dateColumn({label: 'Date', column: 'date'}),
        genericColumn({
            label: 'Time',
            render: {
                show: (object) => {
                    return (<>
                        {!object.start_time && <>(All Day)</>}
                        {object.start_time && <>{formatTime(object.start_time)} - {formatTime(object.end_time)}</>}
                    </>)
                },
            },
        }),
        textColumn({label: 'Location', column: 'location'}),
    ],
};


export const timeSlotsRelationshipEdit = {
    collapsible: true,
    title: 'Shifts',
    tint: 'default',
    type: 'table',
    sort: [['date'], ['start_time']],
    columns: [
        dateColumn({label: 'Date', column: 'date'}),
        timeColumn({label: 'Start', column: 'start_time'}),
        timeColumn({label: 'End', column: 'end_time'}),
        /*
        {
            fn: ({row}) => timeColumn({label: 'End', column: 'end_time', minTime: row.start_time})
        },
        */
        textColumn({label: 'Location', column: 'location'}),
    ],
    newRowData: ({relationship, data}) => {
        let timeSlotDuration = 60;
        let timeSlotStartTime = '';
        if(data && data.length > 0) {
            var mostRecentSlot = data[0];

            if(typeof mostRecentSlot.end_time !== 'undefined' && mostRecentSlot.end_time !== null) {
                timeSlotStartTime = mostRecentSlot.end_time;

                if(mostRecentSlot.hasOwnProperty('start_time')) {
                    timeSlotDuration = differenceInMinutes(dateFromTime(mostRecentSlot.end_time), dateFromTime(mostRecentSlot.start_time));
                    // timeSlotDuration = differenceInMinutes(mostRecentSlot.start_time, mostRecentSlot.end_time);
                }
            }

            return {
                date: mostRecentSlot.date,
                start_time: mostRecentSlot.end_time,
                end_time: formatTimeForDatabase(addMinutes(dateFromTime(mostRecentSlot.end_time), Math.max(timeSlotDuration))),
                location: mostRecentSlot.location,
            };
        }

        return {};
    },
};
